// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"a7b40af3","305":"522f7b9c","311":"d912c652","379":"2191e2e5","482":"054ca7d3","545":"920711d5","921":"84756d5e","975":"8b202744","997":"f7ab71ee"}[chunkId] + ".chunk.js";
};